//IMPORTAÇÃO DAS BIBLIOTECAS-----------------------------------------------------------------------
import { useState, useEffect } from "react"; // Importação de hooks do React para gerenciar estado e efeitos colaterais
import { api } from "../../../../../services/api.js"; // Importação da API para requisições
import { ClipLoader } from "react-spinners"; // Carregamento de spinner
import { toast, ToastContainer } from 'react-toastify';// aviso de notificação
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { MdSecurity } from "react-icons/md"; // Ícone de segurança
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google'; // login google



//IMPORTAÇÃO DOS COMPONENTES-----------------------------------------------------------------------
import styles from "./conta.module.css";// Estilos do componente Conta
import ComponentLoad from "../../../../componentLoad/componentLoad.js";
import { useAppContext } from "../../../../../AppContext.js";
import InfoAnimation from '../../../../infoAnimation/infoAnimation.js'
import InfoAnimationErro from '../../../../infoAnimation/infoAnimationErro.js'
import { FcGoogle } from 'react-icons/fc';
import * as googleOAuth from "../../../../../services/googleOAuth.js";



//COMPONENTE---------------------------------------------------------------------------------------
export default function Conta() {
    // VARIÁVEIS DE ESTADO-----------------------------------------------------
    // Navegação entre páginas
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { isApp } = useAppContext(); // define se está sendo acessado pelo app ou pelo site

    // Estado para controlar o carregamento dos dados iniciais do usuário
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false); // erro ao carregar dados iniciais

    // Estado para armazenar e editar o nome do usuário
    const [defaltName, setDefaultName] = useState(''); //nome atual gravado no banco de dados
    const [name, setName] = useState(''); //nome a ser editado
    const [nameEdit, setNameEdit] = useState(false); //abre input para edição do nome
    const [nameSave, setNameSave] = useState(false) //habilita icone loading para aguardar api salvar nome

    // Estado para armazenar e editar o email do usuário
    const [userLocal, setUserLocal] = useState(false); // estado para verifica se o usuário possui conta cadastrada.
    const [defaltEmail, setDefaultEmail] = useState(''); //email atual gravado no banco  de dados
    const [email, setEmail] = useState(''); // email a ser editado
    const [password, setPassword] = useState(''); // senha do usuário
    const [code, setCode] = useState(''); // código de confirmação do email
    const [emailEdit, setEmailEdit] = useState(false); //abre inputs para edição do email
    const [emailConfPassword, setEmailConfPassword] = useState(false); // habilita icone loading para aguardar confirmação da senha do usuário
    const [emailSave, setEmailSave] = useState(false); // habilita icone loading para aguardar api salvar email
    const [showConfirmation, setShowConfirmation] = useState(false); // abre caixa do codigo de confirmação enviado ao novo e-mail.

    // Estado para criar ou editar a senha do usuário
    const [newPassword, setNewPassword] = useState(''); // nova senha
    const [newPasswordConfirm, setNewPasswordConfirm] = useState(''); // confirmação da nova senha
    const [codePass, setCodePass] = useState(''); // código de confirmção doi email
    const [newPasswordEdit, setNewPasswordEdit] = useState(false); // abre caixa de inputs para edição da senha
    const [passwordSaveLoad, setPasswordSaveLoad] = useState(false); // habilita icone loading para aguardar api enviar código de conf. para email
    const [passwordSave, setPasswordSave] = useState(false); // habilita icone loading para aguardar api salvar senha
    const [showConfirmationPass, setShowConfirmationPass] = useState(false) // abre caixa do codigo de confirmação enviado ao novo e-mail.

    // Estados e handlers para reiniciar conta
    const [deleteEdit, setDeleteEdit] = useState(false); // abre caixa para iniciar reinicialização da conta
    const [deletePassword, setDeletePassword] = useState(''); // senha para solicitar reinicialização da conta
    const [deleteRequesting, setDeleteRequesting] = useState(false); // loading ao solicitar reinicialização (envia senha)
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false); // mostra input do código enviado por email
    const [deleteCode, setDeleteCode] = useState(''); // código de confirmação
    const [deleteConfirming, setDeleteConfirming] = useState(false); // loading ao confirmar reinicialização da conta
    const fraseEsperada = t("I want to reset my tS Notes account"); // frase esperada para confirmação da reinicialização
    const [fraseDelete, setFraseDelete] = useState(''); // frase de confirmação da reinicialização

    // Estado para registrar conta local
    const [registerEdit, setRegisterEdit] = useState(false); // abre inputs para registrar email
    const [registerName, setRegisterName] = useState('');
    const [registerEmail, setRegisterEmail] = useState(''); // email a ser registrado
    const [registerPassword, setRegisterPassword] = useState(''); // senha para confirmar registro
    const [registerPasswordConfirm, setRegisterPasswordConfirm] = useState(''); // confirmação da senha
    const [registerCode, setRegisterCode] = useState(''); // código de confirmação do email
    const [registerConfPassword, setRegisterConfPassword] = useState(false); // loading ao enviar email
    const [registerSave, setRegisterSave] = useState(false); // loading ao confirmar código
    const [showRegisterConfirmation, setShowRegisterConfirmation] = useState(false); // abre caixa do código de confirmação
    const [showRegisterError, setShowRegisterError] = useState(false); // abre caixa para informar o erro ao usuário
    const [registerError, setRegisterError] = useState(''); // mensagem de erro

    // mensagens de sucesso ou erro
    const [showSuccess, setShowSuccess] = useState(false); //abre caixa do sucesso
    const [showSuccessMsg, setShowSuccessMsg] = useState(''); // mensagem de sucesso
    const [showSuccessDuration, setShowSuccessDuration] = useState(0);

    const [showErro, setShowErro] = useState(false);
    const [showErroMsg, setShowErroMsg] = useState('');
    const [showErroDuration, setShowErroDuration] = useState(0);

    const [isRegisteringGoogle, setIsRegisteringGoogle] = useState(false);

    //-------------------------------------------------------------------------



    // EFEITOS COLATERAIS------------------------------------------------------
    // Efeito para carregar os dados do usuário ao montar o componente
    useEffect(() => {
        const loadUserData = async () => {
            try {
                const { data } = await api.get(`/auth/user`);
                setDefaultName(data.name);
                setName(data.name);
                setDefaultEmail(data.email);
                setEmail(data.email);
                setUserLocal(data.userLocal);
                //console.log(data.msg) // para desenvolvimento
            } catch (error) {
                // Exibe a mensagem de erro específica do backend, ou uma mensagem genérica como fallback.
                const errorMessage = "Internal error. Try again later!";
                toast.error(errorMessage);
                setError(true);
                // console.error("Erro ao carregar dados do usuário:", error); // para desenvolvimento
            } finally {
                setLoading(false);
            }
        }
        loadUserData();
    }, []);
    //-------------------------------------------------------------------------



    // NOME DO USUÁRIO---------------------------------------------------------
    // Função para salvar o nome editado
    const handleSaveName = async (e) => {
        e.preventDefault();
        if (name === defaltName) {
            setNameEdit(false);
            return;
        }
        setNameSave(true);
        try {
            const response = await api.put(`/auth/user/name`, { name });
            setName(response.data.name);
            setDefaultName(response.data.name);
            setNameEdit(false);
            // console.log(response.data.msg);  // para desenvolvimento
        } catch (error) {
            toast.error(error.response?.data?.msg || t("Internal error. Try again later!"));
            // console.error(error.response?.data?.msg || "Erro ao atualizar nome.", error);  // para desenvolvimento
        } finally {
            setNameSave(false);
        }
    }
    //-------------------------------------------------------------------------



    // EMAIL DO USUÁRIO--------------------------------------------------------
    // Função para salvar o email editado
    const handleSaveEmail = async (e) => {
        e.preventDefault();
        // cancela em caso de email atual
        if (email === defaltEmail) {
            setEmailEdit(false);
            return;
        }
        // habilita loading
        setEmailConfPassword(true);
        try {
            // chamada da api
            await api.post(`/auth/user/email`, { email, password });
            setEmailConfPassword(true);
            setShowConfirmation(true);
            // console.log(response.data.msg); // para desenvolvimento
        } catch (error) {
            toast.error(error.response.data.msg || t("Internal error. Try again later!"));
            // console.log(error.response.data.msg || "Erro ao alterar e-mail:", error); // para desenvolvimento
        } finally {
            setEmailConfPassword(false);
        }
    };

    // função para confirmar código enviado para o email
    const handleConfirmEmail = async (e) => {
        e.preventDefault();
        setEmailSave(true);
        try {
            const response = await api.post('/auth/user/email/confirm', { code });
            setDefaultEmail(response.data.email);
            setEmail(response.data.email);

            // Resetar o formulário
            setEmailEdit(false);
            setShowConfirmation(false);
            setPassword('');
            setCode('');
            toast.success(t("Email successfully changed!"));
            // console.log(response.data.msg); // para desenvolvimento.
        } catch (error) {
            toast.error(error.response?.data?.msg || t("Internal error. Try again later!"));
            // console.error(error.response?.data?.msg ||"Erro ao confirmar código:", error); // para desenvolvimento
        } finally {
            setEmailSave(false);
        }
    };
    //-------------------------------------------------------------------------



    // SENHA DO USUÁRIO--------------------------------------------------------
    // função para criar nova senha
    const handleSavePassword = async (e) => {
        e.preventDefault();
        if (newPassword !== newPasswordConfirm) {
            toast.error(t("Passwords do not match."));
            return;
        }
        setPasswordSaveLoad(true); // mostra icone de load
        try {
            await api.post('/auth/user/password', { newPassword, newPasswordConfirm });
            setShowConfirmationPass(true); // abre caixa do codigo de confirmação enviado ao novo e-mail.
            // console.log(response.data.msg); // para desenvolvimento
        } catch (error) {
            toast.error(error.response?.data?.msg || t("Internal error. Try again later!"));
            // console.error(error.response?.data?.msg || "Erro ao solicitar alteração de senha.", error); // para desenvolvimento
        } finally {
            setPasswordSaveLoad(false);
        }
    };

    //função para confirmar código enviado para o email
    const handleConfirmPassword = async (e) => {
        e.preventDefault();
        setPasswordSave(true); // mostra icone de load
        try {
            await api.post('/auth/user/password/confirm', { codePass });
            setNewPasswordEdit(false); // fecha caixa de inputs para edição da senha
            setShowConfirmationPass(false); // fecha caixa de confirmação de código
            setNewPassword(''); // limpa input e variavel de senha
            setNewPasswordConfirm(''); // limpa input e variável de confirmação de senha
            setCodePass(''); // limpa input e variável de código
            toast.success(t("Password changed successfully!"));
            // console.log(response.data.msg); // para desenvolvimento
        } catch (error) {
            toast.error(error.response?.data?.msg || t("Internal error. Try again later!"));
            // console.error(error.response?.data?.msg || "Erro ao confirmar o código:", error); // para desenvolvimento
        } finally {
            setPasswordSave(false); // esconde icone de load
        }
    };
    //-------------------------------------------------------------------------


    // reiniciar ts notes-------------------------------------------------------
    // solicita envio do código (envia senha)
    const handleRequestDelete = async (e) => {
        e.preventDefault();
        setDeleteRequesting(true);
        console.log(fraseDelete, fraseEsperada);
        if (!fraseDelete || fraseDelete.toLowerCase() !== fraseEsperada.toLowerCase()) {
            toast.error(t("Please enter the confirmation phrase correctly to proceed."));
            setDeleteRequesting(false);
            return;
        }
        try {
            const response = await api.post('/auth/user/delete', { password: deletePassword });
            setShowDeleteConfirmation(true);
            toast.success(response.data?.msg || t("Code sent to your email."));
        } catch (error) {
            toast.error(error.response?.data?.msg || t("Internal error. Try again later!"));
        } finally {
            setDeleteRequesting(false);
        }
    };

    // confirma reinicialização com o código recebido por e-mail
    const handleConfirmDelete = async (e) => {
        e.preventDefault();
        setDeleteConfirming(true);
        try {
            const response = await api.post('/auth/user/delete/confirm', { code: deleteCode });
            toast.success(response.data?.msg || t("Account successfully reset!"));

            // redireciona para a página de login após 3 segundos
            setTimeout(async () => {
                const logout = await api.post('/auth/logout');
                console.log(logout.data?.msg || "Logged out successfully."); // para desenvolvimento
                localStorage.removeItem('contConectado');
                if (isApp) {
                    window.Android.clearCookies(); // Limpa cookies no WebView do Android (certifique-se de ter essa função implementada na camada nativa)
                }
                navigate('/');
            }, 2000);

        } catch (error) {
            toast.error(error.response?.data?.msg || t("Internal error. Try again later!"));
        } finally {
            setDeleteConfirming(false);
        }
    };
    //-------------------------------------------------------------------------


    // REGISTRAR CONTA LOCAL---------------------------------------------------
    // Função para enviar email e solicitar código de confirmação
    const handleSendRegisterEmail = async (e) => {
        e.preventDefault();
        if (registerPassword !== registerPasswordConfirm) {
            setRegisterError(t("Passwords do not match."));
            setShowRegisterError(true);
            // toast.error(t("Passwords do not match."));
            return;
        }
        setRegisterConfPassword(true);
        try {
            await api.post(`/auth/user/register-local`, { email: registerEmail, password: registerPassword });
            setShowRegisterError(false);
            setRegisterError('');
            setShowRegisterConfirmation(true);
            // toast.success(t("Code sent to your email."));
            // console.log(response.data.msg); // para desenvolvimento
        } catch (error) {
            setShowErroMsg(error.response?.data?.msg || t("Internal error. Try again later!"));
            setShowErroDuration(2500);
            setShowErro(true);
            setRegisterError(error.response?.data?.msg || t("Internal error. Try again later!"));
            setShowRegisterError(true);
            // toast.error(error.response?.data?.msg || t("Internal error. Try again later!"));
            // console.error(error.response?.data?.msg); // para desenvolvimento
        } finally {
            setRegisterConfPassword(false);
        }
    };

    // Função para confirmar código e registrar conta local
    const handleConfirmRegisterEmail = async (e) => {
        e.preventDefault();
        setRegisterSave(true);
        try {
            const response = await api.post('/auth/user/register-local/confirm', { name: registerName, code: registerCode });
            setDefaultEmail(response.data.email);
            setName(response.data.name);
            setEmail(response.data.email);
            setDefaultName(response.data.name);
            setUserLocal(false); // Converte de conta local para conta registrada

            localStorage.setItem('localUserBlock', true); // impedir usuário criar outra conta local
            localStorage.setItem('typeUser', 'registrado');

            // Resetar o formulário
            setRegisterEdit(false);
            setShowRegisterConfirmation(false);
            setRegisterName('');
            setRegisterEmail('');
            setRegisterPassword('');
            setRegisterCode('');
            setShowRegisterError(false);
            setRegisterError('');
            setShowSuccessDuration(2500);
            setShowSuccessMsg(t("Account successfully registered!"))
            setShowSuccess(true);
            // console.log(response.data.msg); // para desenvolvimento
        } catch (error) {
            setShowErroMsg(error.response?.data?.msg || t("Internal error. Try again later!"));
            setShowErroDuration(2500);
            setShowErro(true);
            setRegisterError(error.response?.data?.msg || t("Internal error. Try again later!"));
            setShowRegisterError(true);
            // toast.error(error.response?.data?.msg || t("Internal error. Try again later!"));
            // console.error(error.response?.data?.msg); // para desenvolvimento
        } finally {
            setRegisterSave(false);
        }
    };
    //-------------------------------------------------------------------------

    // Google Registration Handler
    const handleGoogleRegistrationSuccess = (data) => {
        setDefaultEmail(data.email);
        setName(data.name);
        setEmail(data.email);
        setDefaultName(data.name);
        setUserLocal(false);
        setRegisterEdit(false);
        setShowSuccessDuration(2500);
        setShowSuccessMsg(t("Account successfully registered!"));
        setShowSuccess(true);
        localStorage.setItem('localUserBlock', true); // impedir usuário criar outra conta local
        localStorage.setItem('typeUser', 'registrado');
    };

    const handleGoogleRegistrationError = (msg) => {
        setShowErroMsg(msg);
        setShowErroDuration(2500);
        setShowErro(true);
    };


    // Native Google Registration Callback setup
    useEffect(() => {
        const cleanup = googleOAuth.setupGoogleNativeCallbacks(
            (idToken) => {
                googleOAuth.processGoogleRegistration(
                    idToken,
                    {
                        onSuccess: handleGoogleRegistrationSuccess,
                        onError: handleGoogleRegistrationError,
                        setIsSubmitting: setIsRegisteringGoogle
                    },
                    t
                );
            },
            (statusCode) => {
                console.error("Google Registration Failure. Status Code:", statusCode);
                handleGoogleRegistrationError(t("Failed to authenticate with Google."));
            }
        );

        return cleanup;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [t]);

    const handleGoogleWebRegistrationSuccess = (credentialResponse) => {
        const idToken = credentialResponse?.credential;
        if (!idToken) {
            handleGoogleRegistrationError(t("Failed to authenticate with Google."));
            return;
        }

        googleOAuth.processGoogleRegistration(
            idToken,
            {
                onSuccess: handleGoogleRegistrationSuccess,
                onError: handleGoogleRegistrationError,
                setIsSubmitting: setIsRegisteringGoogle,
            },
            t
        );
    };

    const handleGoogleAppLogin = () => {
        googleOAuth.handleNativeGoogleLogin(t, handleGoogleRegistrationError);
    };


    //html do componente
    return (
        <div className={styles.container}>
            {/* Exibir spinner enquanto os dados estão sendo carregados */}
            {loading ? (
                <div className={styles.spinnerContainer}>
                    <ComponentLoad />
                </div>
            ) : (
                <>
                    {error ? (
                        <div className={styles.errorPanel}>
                            <p>{t("Error loading user data. Please try again!")}</p>
                        </div>
                    ) : (
                        <>
                            {/* Caso o usuário não seja local */}
                            {!userLocal && (
                                <>
                                    {/* Formulário para editar o nome do usuário */}
                                    <form className={styles.preferencesForm} onSubmit={handleSaveName}>
                                        <div className={styles.themeLabel}>{t('Name')}:
                                            {!nameEdit ? (
                                                //nome atual
                                                <div>
                                                    <label className={styles.dataLabel}>{name}</label>
                                                    <div className={styles.ButtonContainer}>
                                                        <input type="button" value={t("edit")} className={styles.Button} onClick={() => { setNameEdit(true) }} />
                                                    </div>
                                                </div>
                                            ) : (
                                                //edição de nome
                                                <span className={styles.dataInput}>
                                                    <div>
                                                        <input
                                                            required
                                                            autoFocus
                                                            placeholder={t("Enter your name")}
                                                            type="text"
                                                            value={name}
                                                            onChange={(e) => setName(e.target.value)}
                                                            className={styles.input}
                                                            maxLength={50}
                                                            disabled={nameSave}
                                                        />
                                                        <span className={styles.spinner}>
                                                            <ClipLoader color="#009900ff" loading={nameSave} size={20} />
                                                        </span>
                                                    </div>
                                                    <div className={styles.ButtonContainer}>
                                                        <input type="submit" value={t("save")} className={styles.Button} />
                                                        <input type="button" value={t("cancel")} className={styles.ButtonCancel} onClick={() => { setNameEdit(false); setName(defaltName) }} />
                                                    </div>
                                                </span>
                                            )}
                                        </div>
                                    </form>

                                    {/* Formulário para editar o email do usuário */}
                                    <form className={styles.preferencesForm} onSubmit={showConfirmation ? handleConfirmEmail : handleSaveEmail}>
                                        <div className={styles.themeLabel}>Email:
                                            {!emailEdit ? (
                                                //email atual
                                                <div>
                                                    <label className={styles.dataLabel}>{email}</label>
                                                    <div className={styles.ButtonContainer}>
                                                        <input type="button" value={t("edit")} className={styles.Button} onClick={() => { setEmailEdit(true); setEmail("") }} />
                                                    </div>
                                                </div>
                                            ) : (
                                                //edição de email
                                                <span className={styles.dataInput}>
                                                    <div>
                                                        <input
                                                            aria-label={t("Enter your new email")}
                                                            required
                                                            autoFocus
                                                            placeholder={t("Enter your new email")}
                                                            type="email"
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            className={styles.input}
                                                            disabled={showConfirmation || emailConfPassword}
                                                        />
                                                    </div>
                                                    <div>
                                                        <input
                                                            aria-label={t("Enter your password")}
                                                            required
                                                            placeholder={t("Enter your password")}
                                                            type="password"
                                                            className={styles.input}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            disabled={showConfirmation || emailConfPassword}
                                                        />
                                                        <span className={styles.spinner}>
                                                            <ClipLoader color="#009900ff" loading={emailConfPassword} size={20} />
                                                        </span>
                                                    </div>
                                                    {showConfirmation && (
                                                        <section className={styles.codConfirmation}>
                                                            <p className={styles.codConfirmationText}>
                                                                {t("It is necessary to confirm the code sent to your email to continue.")}
                                                            </p>
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    placeholder={t("Confirmation code")}
                                                                    aria-label={t("Confirmation code")}
                                                                    className={styles.inputConfirmation}
                                                                    required
                                                                    maxLength={6}
                                                                    minLength={6}
                                                                    onChange={(e) => setCode(e.target.value)}
                                                                    autoFocus
                                                                    disabled={emailSave}
                                                                />
                                                                <span className={styles.spinner}>
                                                                    <ClipLoader color="#009900ff" loading={emailSave} size={20} />
                                                                </span>
                                                            </div>
                                                        </section>
                                                    )}
                                                    <div className={styles.ButtonContainer}>
                                                        {showConfirmation ? (
                                                            <input type="submit" value={t("confirm")} className={styles.Button} />
                                                        ) : (
                                                            <input type="submit" value={t("send")} className={styles.Button} />
                                                        )}
                                                        <input type="button" value={t("cancel")} className={styles.ButtonCancel} onClick={() => { setEmailEdit(false); setEmailSave(false); setShowConfirmation(false); setEmail(defaltEmail) }} />
                                                    </div>
                                                </span>
                                            )}
                                        </div>
                                    </form>

                                    {/* formulário para criar ou alterar senha do usuário */}
                                    <form className={styles.preferencesForm} onSubmit={showConfirmationPass ? handleConfirmPassword : handleSavePassword}>
                                        <div className={styles.themeLabel}>{t('Create or change password')}:
                                            {!newPasswordEdit ? (
                                                //senha ficticia
                                                <div>
                                                    <label className={styles.dataLabel}>********</label>
                                                    <div className={styles.ButtonContainer}>
                                                        <input type="button" value={t("edit")} className={styles.Button} onClick={() => { setNewPasswordEdit(true); setNewPassword(""); setNewPasswordConfirm("") }} />
                                                    </div>
                                                </div>
                                            ) : (
                                                //criar ou alterar senha
                                                <span className={styles.dataInput}>
                                                    <div>
                                                        <input
                                                            required
                                                            autoFocus
                                                            placeholder={t("Enter your new password")}
                                                            type="password"
                                                            value={newPassword}
                                                            onChange={(e) => setNewPassword(e.target.value)}
                                                            className={styles.input}
                                                            minLength={6}
                                                            maxLength={20}
                                                            disabled={showConfirmationPass || passwordSaveLoad}
                                                        />
                                                    </div>
                                                    <div>
                                                        <input
                                                            required
                                                            placeholder={t("Confirm your new password")}
                                                            type="password"
                                                            className={styles.input}
                                                            onChange={(e) => setNewPasswordConfirm(e.target.value)}
                                                            minLength={6}
                                                            maxLength={20}
                                                            disabled={showConfirmationPass || passwordSaveLoad}
                                                        />
                                                        <span className={styles.spinner}>
                                                            <ClipLoader color="#009900ff" loading={passwordSaveLoad} size={20} />
                                                        </span>
                                                    </div>
                                                    {showConfirmationPass && (
                                                        <section className={styles.codConfirmation}>
                                                            <p className={styles.codConfirmationText}>
                                                                {t("It is necessary to confirm the code sent to your email to continue.")}
                                                            </p>
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    placeholder={t("Confirmation code")}
                                                                    aria-label={t("Confirmation code")}
                                                                    className={styles.inputConfirmation}
                                                                    required
                                                                    maxLength={6}
                                                                    minLength={6}
                                                                    onChange={(e) => setCodePass(e.target.value)}
                                                                    autoFocus
                                                                    disabled={passwordSave}
                                                                />
                                                                <span className={styles.spinner}>
                                                                    <ClipLoader color="#009900ff" loading={passwordSave} size={20} />
                                                                </span>
                                                            </div>
                                                        </section>
                                                    )}
                                                    <div className={styles.ButtonContainer}>
                                                        {showConfirmationPass ? (
                                                            <input type="submit" value={t("confirm")} className={styles.Button} />
                                                        ) : (
                                                            <input type="submit" value={t("send")} className={styles.Button} />
                                                        )}
                                                        <input
                                                            type="button"
                                                            value={t("cancel")}
                                                            className={styles.ButtonCancel}
                                                            onClick={() => {
                                                                setNewPasswordEdit(false);
                                                                setPasswordSaveLoad(false);
                                                                setShowConfirmationPass(false);
                                                                setNewPassword("");
                                                                setNewPasswordConfirm("");
                                                                setCodePass("");
                                                            }}
                                                        />
                                                    </div>
                                                </span>
                                            )}
                                        </div>
                                    </form>

                                    {/* Formulário para reiniciar conta */}
                                    <form className={styles.preferencesForm} onSubmit={showDeleteConfirmation ? handleConfirmDelete : handleRequestDelete}>
                                        <div className={styles.themeLabel}>{t("Restart tS Notes App")}:
                                            {!deleteEdit ? (
                                                <div>
                                                    <label className={styles.dataLabelDelete}>{t("This action is irreversible. All your notes will be permanently deleted!")}</label>
                                                    <div className={styles.ButtonContainer}>
                                                        <input
                                                            type="button"
                                                            value={t("request")}
                                                            className={styles.Button}
                                                            onClick={() => { setDeleteEdit(true); setDeletePassword(''); setFraseDelete(''); }}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <span className={styles.dataInput}>
                                                    {!showDeleteConfirmation ? (
                                                        <>
                                                            <div>
                                                                <input
                                                                    required
                                                                    autoFocus
                                                                    placeholder={t("Enter your password")}
                                                                    type="password"
                                                                    value={deletePassword}
                                                                    onChange={(e) => setDeletePassword(e.target.value)}
                                                                    className={styles.input}
                                                                    disabled={deleteRequesting}
                                                                />
                                                                <span className={styles.spinner}>
                                                                    <ClipLoader color="#009900ff" loading={deleteRequesting} size={20} />
                                                                </span>
                                                            </div>
                                                            <label className={styles.dataLabelFrase}>
                                                                {t("To confirm, type the exact phrase below:")}
                                                            </label>
                                                            <strong>{fraseEsperada}</strong>
                                                            <div>
                                                                <input
                                                                    required
                                                                    value={fraseDelete}
                                                                    onChange={(e) => setFraseDelete(e.target.value)}
                                                                    className={styles.input}
                                                                    disabled={deleteRequesting}
                                                                    placeholder={t("Enter the confirmation phrase")}
                                                                />
                                                            </div>
                                                            <div className={styles.ButtonContainer}>
                                                                <input type="submit" value={t("send")} className={styles.Button} />
                                                                <input
                                                                    type="button" value={t("cancel")}
                                                                    className={styles.ButtonCancel}
                                                                    onClick={() => { setDeleteEdit(false); setDeletePassword(''); setShowDeleteConfirmation(false); setFraseDelete(''); }}
                                                                />
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <section className={styles.codConfirmation}>
                                                                <p className={styles.codConfirmationText}>
                                                                    {t("It is necessary to confirm the code sent to your email to continue.")}
                                                                </p>
                                                                <div>
                                                                    <input
                                                                        type="text"
                                                                        placeholder={t("Confirmation code")}
                                                                        aria-label={t("Confirmation code")}
                                                                        className={styles.inputConfirmation}
                                                                        required
                                                                        maxLength={6}
                                                                        minLength={6}
                                                                        onChange={(e) => setDeleteCode(e.target.value)}
                                                                        autoFocus
                                                                        disabled={deleteConfirming}
                                                                    />
                                                                    <span className={styles.spinner}>
                                                                        <ClipLoader color="#009900ff" loading={deleteConfirming} size={20} />
                                                                    </span>
                                                                </div>
                                                            </section>
                                                            <div className={styles.ButtonContainer}>
                                                                <input type="submit" value={t("confirm")} className={styles.Button} />
                                                                <input type="button" value={t("cancel")} className={styles.ButtonCancel} onClick={() => { setDeleteEdit(false); setShowDeleteConfirmation(false); setDeleteCode(''); setDeletePassword(''); }} />
                                                            </div>
                                                        </>
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                    </form>
                                </>
                            )}

                            {/* Caso o usuário seja local */}
                            {userLocal && (
                                <>
                                    {/* Registrar conta local do usuário.  */}
                                    <form className={styles.registerForm} onSubmit={showRegisterConfirmation ? handleConfirmRegisterEmail : handleSendRegisterEmail}>
                                        <div className={styles.themeLabel}>
                                            <div className={styles.registerFormHeader}>
                                                <MdSecurity className={styles.registerFormIcon} />
                                                <span className={styles.registerFormTitle}>
                                                    {t('Register Account')}
                                                    <span className={styles.registerFormBadge}>{t('Recommended')}</span>
                                                </span>
                                            </div>
                                            {!registerEdit ? (
                                                <div>
                                                    <label className={styles.registerFormDescription}>
                                                        {t("Access your notes on all your devices by signing up for free with an email. Your notes will be synced to the cloud!")}
                                                    </label>
                                                    <div className={styles.registerFormButtonContainer}>
                                                        <input
                                                            type="button"
                                                            value={t("register")}
                                                            className={styles.registerFormButton}
                                                            onClick={() => { setRegisterEdit(true); setRegisterName(''); setRegisterEmail(''); setRegisterPassword(''); setRegisterPasswordConfirm(''); setShowRegisterError(false); setRegisterError(''); }}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <span className={styles.dataInput}>
                                                    <div>
                                                        <input
                                                            placeholder={t("Enter your name")}
                                                            aria-label={t("Enter your name")}
                                                            required
                                                            type="text"
                                                            value={registerName}
                                                            onChange={(e) => setRegisterName(e.target.value)}
                                                            className={styles.registerFormInput}
                                                            disabled={showRegisterConfirmation || registerConfPassword}
                                                            autoFocus
                                                            maxLength={50}
                                                        />
                                                    </div>
                                                    <div>
                                                        <input
                                                            aria-label={t("Enter your email")}
                                                            placeholder={t("Enter your email")}
                                                            required
                                                            type="email"
                                                            value={registerEmail}
                                                            onChange={(e) => setRegisterEmail(e.target.value)}
                                                            className={styles.registerFormInput}
                                                            disabled={showRegisterConfirmation || registerConfPassword}
                                                        />
                                                    </div>
                                                    <div>
                                                        <input
                                                            aria-label={t("Enter your password")}
                                                            required
                                                            placeholder={t("Enter your password")}
                                                            type="password"
                                                            value={registerPassword}
                                                            onChange={(e) => setRegisterPassword(e.target.value)}
                                                            className={styles.registerFormInput}
                                                            disabled={showRegisterConfirmation || registerConfPassword}
                                                        />
                                                    </div>
                                                    <div>
                                                        <input
                                                            aria-label={t("Confirm your password")}
                                                            required
                                                            placeholder={t("Confirm your password")}
                                                            type="password"
                                                            value={registerPasswordConfirm}
                                                            onChange={(e) => setRegisterPasswordConfirm(e.target.value)}
                                                            className={styles.registerFormInput}
                                                            disabled={showRegisterConfirmation || registerConfPassword}
                                                        />
                                                        <span className={styles.registerFormSpinner}>
                                                            <ClipLoader color="#ffffff" loading={registerConfPassword} size={20} />
                                                        </span>
                                                    </div>
                                                    {showRegisterConfirmation && (
                                                        <section className={styles.registerFormCodeConfirmation}>
                                                            <p className={styles.registerFormCodeText}>
                                                                {t("It is necessary to confirm the code sent to your email to continue.")}
                                                            </p>
                                                            <div>
                                                                <input
                                                                    type="text"
                                                                    placeholder={t("000000")}
                                                                    aria-label={t("Confirmation code")}
                                                                    className={styles.registerFormCodeInput}
                                                                    required
                                                                    maxLength={6}
                                                                    minLength={6}
                                                                    onChange={(e) => setRegisterCode(e.target.value)}
                                                                    autoFocus
                                                                    disabled={registerSave}
                                                                />
                                                                <span className={styles.registerFormSpinner}>
                                                                    <ClipLoader color="#ffffff" loading={registerSave} size={20} />
                                                                </span>
                                                            </div>
                                                        </section>
                                                    )}

                                                    {/* caso alguma mensagem de erro venha do backend */}
                                                    {showRegisterError && (
                                                        <section className={styles.registerFormError}>
                                                            <p className={styles.registerFormErrorText}>
                                                                {registerError}
                                                            </p>
                                                        </section>
                                                    )}
                                                    <div className={styles.registerFormButtonContainer}>
                                                        {showRegisterConfirmation ? (
                                                            <input type="submit" value={t("confirm")} className={styles.registerFormButton} />
                                                        ) : (
                                                            <input type="submit" value={t("send")} className={styles.registerFormButton} />
                                                        )}
                                                        <input
                                                            type="button"
                                                            value={t("cancel")}
                                                            className={styles.registerFormButtonCancel}
                                                            onClick={() => {
                                                                setRegisterEdit(false);
                                                                setShowRegisterConfirmation(false);
                                                                setShowRegisterError(false);
                                                                setRegisterError('');
                                                                setRegisterName('');
                                                                setRegisterEmail('');
                                                                setRegisterPassword('');
                                                                setRegisterPasswordConfirm('');
                                                                setRegisterCode('');
                                                                setRegisterConfPassword(false);
                                                            }}
                                                        />
                                                    </div>
                                                </span>
                                            )}
                                        </div>

                                        <div className={styles.dividerContainer}>
                                            <div className={styles.dividerLine}></div>
                                            <span className={styles.dividerText}>{t("or")}</span>
                                            <div className={styles.dividerLine}></div>
                                        </div>

                                        {/* login com conta google */}
                                        {isApp ? (
                                            // Botão para o App Nativo
                                            <div className={styles.googleAppButtonContainer}>
                                                <button
                                                    type="button"
                                                    className={styles.googleAppButton}
                                                    onClick={handleGoogleAppLogin}
                                                    disabled={isRegisteringGoogle}
                                                >
                                                    {isRegisteringGoogle ? (
                                                        <ClipLoader color="#ffffff" loading={isRegisteringGoogle} size={20} />
                                                    ) : (
                                                        <>
                                                            <FcGoogle className={styles.googleIconApp} />
                                                            <span>{t("Use Google account")}</span>
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                        ) : (
                                            //login com conta google web 
                                            <GoogleOAuthProvider clientId={googleOAuth.GOOGLE_CLIENT_ID}>
                                                <div className={styles.googleAppButtonContainer}>
                                                    <GoogleLogin
                                                        onSuccess={handleGoogleWebRegistrationSuccess}
                                                        onError={() => handleGoogleRegistrationError(t("Failed to authenticate with Google."))}
                                                        theme="outline"
                                                        type="standard"
                                                        shape="pill"
                                                        width="285px"
                                                        text="signin_with"
                                                    />
                                                </div>
                                            </GoogleOAuthProvider>
                                        )}
                                    </form>
                                </>
                            )}

                            {/* link para acessar a conta toSKy Apps */}
                            <div className={styles.linkContainer}>
                                <a href="https://toskyapps.com" target="_blank" rel="noopener noreferrer" className={styles.link}>
                                    {t("Access my toSKy Apps account")}
                                </a>
                            </div>

                            {/* mensagem de sucesso ao realizar ações */}
                            {showSuccess && (
                                <InfoAnimation
                                    message={showSuccessMsg}
                                    duration={showSuccessDuration}
                                    onClose={() => setShowSuccess(false)}
                                />
                            )}

                            {/* mensagem de erro ao realizar ações */}
                            {showErro && (
                                <InfoAnimationErro
                                    message={showErroMsg}
                                    duration={showErroDuration}
                                    onClose={() => setShowErro(false)}
                                />
                            )}

                            {/* Exibir mensagens ao usuário */}
                            <ToastContainer
                                position="top-right"
                                autoClose={6000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                            />
                        </>
                    )}
                </>
            )}
        </div>
    );
}